import React from "react";
import "./NoTextsMessage.scss";

export function NoTextsMessage() {
  return (
    <div className="no-texts-message-container">
      <span className="no-texts-message">
        Não existem textos compartilhados no momento
      </span>
    </div>
  );
}
